export const state = {
  isDbStatsLoading: false,
  numDocuments: 0,
  notificationDocs: [],

  isRssFeedsLoading: false,
  numRssUpdates: 0,
  feeds: [],

  notificationPrefs: {
    isLoading: true,
    enabled: false,
    frequency: 'WEEK',
  },
};
